import { DOCUMENTS_CACHE_TIME } from '@constants/documents.constants';
import { DefaultOptions } from '@tanstack/react-query';

export const queryConfig: DefaultOptions = {
  queries: {
    gcTime: DOCUMENTS_CACHE_TIME,
    retry: false,
  },
};
